module.exports = __webpack_public_path__ + "img/chevron.47b5fb52.svg";